import Header from "@/types/app/header";

export default class CustomerCompany {
  public static header: Header[] = [
    {
      text: "Updated date",
      align: "start",
      sortable: true,
      value: "updatedDate",
      class: "item-table-header item-table-header-entryDateTime",
      width: ""
    },    
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "name",
      class: "item-table-header item-table-header-name",
      width: ""
    },    
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header item-table-header-name",
      width: ""
    },    
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
